import { Size } from '../constants';

import { TabNavigatorSize, TabNavigatorType } from './TabNavigator.consts';
import {
  tabNavigatorContainerStyles,
  tabOptionContainerStyles
} from './TabNavigator.styles';
import { TabNavigatorOption, TabOption } from './TabNavigatorOption';

interface TabNavigatorProps<TabValue> {
  activeTab: TabValue;
  tabOptions: TabOption<TabValue>[];
  onClick?: (tab: TabValue) => void;
  orientation?: TabNavigatorType;
  size?: TabNavigatorSize;
}

const TabNavigator = <TabValue,>({
  activeTab,
  tabOptions,
  onClick,
  size = Size.LARGE,
  orientation = TabNavigatorType.HORIZONTAL
}: TabNavigatorProps<TabValue>) => {
  const containerClasses = tabNavigatorContainerStyles({
    orientation,
    tabSize: size
  });

  return (
    <div className={containerClasses} data-testid="tab-navigator">
      {tabOptions.map((tabOption) => {
        const optionContainerClasses = tabOptionContainerStyles({
          orientation
        });

        return (
          <div
            className={optionContainerClasses}
            data-testid={`tab-option-container-${String(tabOption.value)}`}
            key={String(tabOption.value)}
          >
            <TabNavigatorOption<TabValue>
              isSelected={tabOption.value === activeTab}
              onClick={onClick}
              size={size}
              tabOption={tabOption}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TabNavigator;
